import { Route, Routes } from "react-router-dom";

import { EditProvider } from "../contexts/edit-context";
import RoleGuard from "../guards/RoleGuard";
import { UserRole } from "../types/user";
import HomeAdmin from "../pages/home-admin/HomeAdmin";
import EditOject from "../pages/objects/EditObject";
import LitsObjects from "../pages/objects/LitsObjects";
import AddObject from "../pages/objects/AddObject";
import ImportTemplate from "../pages/objects/ImportTemplate";
import ManageAddresses from "../pages/addresses/ManageAddresses";
import Users from "../pages/users/Users";
import User from "../pages/users/User";
import Sites from "../pages/sites/Sites";

export default function AdminRoute () {
  return (
    <EditProvider>
      <Routes>
        <Route index Component={HomeAdmin} />
        <Route path="objects" Component={LitsObjects} />
        <Route path="objects/import-template" element={<RoleGuard role={[UserRole.admin, UserRole.site_admin]}><ImportTemplate /></RoleGuard>} />
        <Route path="objects/add" Component={AddObject} />
        <Route path="objects/edit" Component={EditOject} />
        <Route path="addresses" element={<RoleGuard role={UserRole.admin}><ManageAddresses /></RoleGuard>} />
        <Route path="sites" element={<RoleGuard role={[UserRole.admin, UserRole.site_admin]}><Sites /></RoleGuard>} />
        <Route path="users" element={<RoleGuard role={[UserRole.admin, UserRole.site_admin]}><Users /></RoleGuard>} />
        <Route path="users/:id" element={<RoleGuard role={[UserRole.admin, UserRole.site_admin]}><User /></RoleGuard>} />
      </Routes>
    </EditProvider>
  )
}